import { useState } from "react";
import { Method, REACT_APP_API_URL } from "../../api/base";
import { Callbacks, RequestState } from "./types";

type CallFunction<T> = (method: Method, relativeUrl: string, payload?: object, callbacks?: Callbacks<T>) => void;

export default function useDynamicRequest<T>(): [RequestState<T>, CallFunction<T>] {
    const [status, setStatus] = useState<RequestState<T>>({
        isLoading: false,
        hasError: false,
        data: null,
    });

    const call = (method: Method, relativeUrl: string, payload?: object, callbacks?: Callbacks<T>) => {
        setStatus({ ...status, isLoading: true });

        fetch(`${REACT_APP_API_URL}${relativeUrl}`,
            {
                method,
                credentials: 'include',
                body: payload ? JSON.stringify(payload) : undefined,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        )
            .then(res => res.json())
            .then(data => {
                setStatus({
                    isLoading: false,
                    hasError: false,
                    data: data,
                });
                if (callbacks && callbacks.onSuccess) {
                    callbacks.onSuccess(data);
                }
            })
            .catch(err => {
                console.error("Something went wrong while dinamically requesting", relativeUrl, ":", err.message);
                setStatus({
                    isLoading: false,
                    hasError: true,
                    data: null,
                });
                if (callbacks && callbacks.onError) {
                    callbacks.onError(err);
                }
            });
    };

    return [
        status,
        call
    ];
}